import { gql } from "@apollo/client";

export const GET_CAR = gql(`
    query Car($id: ID!) {
        cars(id: $id) {
            data {
                id
                licence
                vin
                additional_info
                freestock_tire
                status
                is_lease
                comment
                tiresets {
                    id
                    type
                    sleep_set
                    in_hotel
                    tire_rim
                    comment
                    position {
                        id
                    }
                    tires {
                        id
                        brand
                        brand_type
                        type
                        ean
                        profile_depth
                        size
                        run_flat
                        car_position
                        status
                    }
                    car {
                        id
                    }
                    requests {
                        id
                        source_type
                        source_id
                        type
                        invoice_status
                        pickup_and_delivery_date
                        state
                        stateFlow {
                            completed
                            refused
                            cancelled
                            value
                            type
                        }
                        invoiced
                        work_order_number
                        availableTransitions
                        created_at
                        relation {
                          id
                          name
                        }
                        user {
                          id
                        }
                        requestTires {
                            id
                            tire {
                                id
                                car_position
                            }
                        }
                    }
                    storedLatestRequest {
                        id
                        source_type
                        source_id
                        type
                        invoice_status
                        pickup_and_delivery_date
                        state
                        stateFlow {
                            completed
                            refused
                            cancelled
                            value
                            type
                        }
                        invoiced
                        work_order_number
                        availableTransitions
                        created_at
                        relation {
                          id
                          name
                        }
                        user {
                          id
                        }
                    }
                  activeRequests {
                      id
                      source_type
                      source_id
                      type
                      invoice_status
                      pickup_and_delivery_date
                      state
                      stateFlow {
                        completed
                        refused
                        cancelled
                        value
                        type
                      }
                      invoiced
                      work_order_number
                      availableTransitions
                      created_at
                      relation {
                        id
                        name
                      }
                      user {
                        id
                      }
                    }
                    sticker {
                      svgUrl
                      pdfUrl
                    }
                }
                relation {
                    id
                    name
                }
                customer {
                    id
                }
            }
        }
    }
`);

export const GET_CAR_WITH_CONTEXT = gql(`
    query carWithContext($id: ID!) {
        carWithContext(id: $id) {
            tireset_details {
                is_pickup_disabled
                request_details {
                    has_recent_delivery_without_pickup
                    active_pickup_request {
                        id
                        source_type
                        source_id
                        type
                        invoice_status
                        is_from_dbb_api
                        pickup_and_delivery_date
                        in_out_storage
                        state
                        invoiced
                        work_order_number
                        comment
                        availableTransitions
                        created_at
                        updated_at
                        status_updated
                        active
                        freestock
                        tireset_cleaning
                        label
                        finalized
                        stateFlow {
                            completed
                            refused
                            cancelled
                            value
                            type
                        }
                    }
                    active_delivery_request {
                        id
                        source_type
                        source_id
                        type
                        invoice_status
                        is_from_dbb_api
                        pickup_and_delivery_date
                        in_out_storage
                        state
                        invoiced
                        work_order_number
                        comment
                        availableTransitions
                        created_at
                        updated_at
                        status_updated
                        active
                        freestock
                        tireset_cleaning
                        label
                        finalized
                        stateFlow {
                            completed
                            refused
                            cancelled
                            value
                            type
                        }
                  }
                }
                tireset {
                    id
                    type
                    sleep_set
                    in_hotel
                    tire_rim
                    comment
                    dbb_source_id
                    label
                    getPickupDeliveryDates {
                      firstDate
                      forbiddenDates
                    }
                    storedLatestRequest {
                      id
                      source_type
                      source_id
                      type
                      pickup_and_delivery_date
                      state
                      invoiced
                      work_order_number
                  }
                }
            }
            car {
                id
                licence
                additional_info
                status
            }
            tireSetSelection {
                pickup {
                    tireset
                    reason
                }
                deliver {
                    tireset
                    reason
                }
            }
            defaultRequestType {
                type
                reason
            }
        }
    }
`);
